module.exports = __webpack_public_path__ + "img/client_7.33bc6c94.png";